import { useTranslation } from 'react-i18next';

export default function FeatureCards() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-search-eye-line',
      titleKey: 'features.card1_title',
      descKey: 'features.card1_desc',
    },
    {
      icon: 'ri-scales-3-line',
      titleKey: 'features.card2_title',
      descKey: 'features.card2_desc',
    },
    {
      icon: 'ri-timer-flash-line',
      titleKey: 'features.card3_title',
      descKey: 'features.card3_desc',
    },
  ];

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-14">
          <p className="text-xs font-label font-medium text-foreground-400 uppercase tracking-wider mb-3">{t('features.subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl">
            {t('features.title')}
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-8 md:p-10 hover:bg-background-50 transition-colors group"
            >
              <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center mb-6 group-hover:bg-primary-50 transition-colors">
                <i className={`${feature.icon} text-foreground-700 text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {t(feature.titleKey)}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {t(feature.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}